import { render, staticRenderFns } from "./audioIcon.vue?vue&type=template&id=3a8cb720&scoped=true"
import script from "./audioIcon.vue?vue&type=script&lang=js"
export * from "./audioIcon.vue?vue&type=script&lang=js"
import style0 from "./audioIcon.vue?vue&type=style&index=0&id=3a8cb720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cb720",
  null
  
)

export default component.exports